(function() {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('ResourceService', [
        '$rootScope',
        '$http',
        '$q',
        'EndpointService',
        'RightsUtil',
        'AppConstants',
        'ServiceHelper',
        ResourceService
    ]);

    function ResourceService($rootScope, $http, $q, EndpointService, RightsUtil, AppConstants, ServiceHelper) {
        var resourceService = {},
            SERVICE_ROOT = function(isNewAPI) {
                return isNewAPI ? EndpointService.endpoint(true) + 'resources/' : EndpointService.endpoint() + 'resource/';
            };

        // AppConstant bindings
        var collaboratorTypes = AppConstants.CollaboratorTypes,
            roleTypes = AppConstants.RoleTypes,
            globalRoles = AppConstants.GlobalRoles,
            permissions = AppConstants.Permissions,
            httpMethods = AppConstants.HttpMethods;

        // permissiveDict is a dictionary from a role to a integer. 
        // Larger the number is, more permissive the role will be.
        var permissiveDict = {};
        permissiveDict[globalRoles.VIEWER] = 0;
        permissiveDict[globalRoles.CONTRIBUTOR] = 1;
        permissiveDict[globalRoles.COOWNER] = 2;
        permissiveDict[globalRoles.OWNER] = 3;
        /*
         * @ngdoc method
         * @name ResourceService#addResourcePermissions
         *
         * @param {String} resourceId The resource id
         *        {String} role The role that will be given to Collaborators on this resource.
         *        {Object|Array} collaborators The array of collabrator that will be given permission on this resource.
         *        {String} message The message that will be sent to collabrators.
         *
         * @returns {Promise} Future object representing the result of Adding or Updating Collaborators.
         */
        resourceService.addResourcePermissions = function(resourceId, role, collaborators, message) {
            var principals = [],
                config = null;

            angular.forEach(collaborators, function(value) {
                var collaborator = {
                    Id: value.id || value.Id,
                    Type: value.type || value.Type
                };

                if (role) {
                    //for the current share modal, which only has one role each submittion
                    if (role === globalRoles.VIEWER) {
                        collaborator.Role = globalRoles.VIEWER;
                    } else if (role === globalRoles.CONTRIBUTOR) {
                        collaborator.Role = globalRoles.CONTRIBUTOR;
                    } else if (role === globalRoles.COOWNER) {
                        collaborator.Role = globalRoles.COOWNER;
                    }
                } else {
                    //for the new share modal, which can have different roles for each user
                    collaborator.Role = value.role;
                }

                if (value.type === collaboratorTypes.GROUP && value.vendor) {
                    collaborator.Vendor = value.vendor;
                }

                principals.push(collaborator);
            });

            config = {
                url: SERVICE_ROOT(true) + resourceId + '/permissions',
                method: httpMethods.POST,
                data: {
                    Principals: principals,
                    Options: {
                        Email: {
                            Message: message
                        }
                    }
                }
            };

            return $http(EndpointService.tokenize(config));
        };

        // Describes the permissions for a given resource id.
        resourceService.describeResourcePermissions = function(resourceId, extensions) {
            var config = {
                url: SERVICE_ROOT(true) + resourceId + "/permissions",
                method: httpMethods.GET,
                params: {
                    extension: extensions
                }
            };
            return $http(EndpointService.tokenize(config));
        };

        resourceService.deleteResourcePermission = function(resourceId, principalId) {
            var config = {
                url: SERVICE_ROOT(true) + resourceId + "/permissions/" + principalId,
                method: httpMethods.DELETE
            };
            return $http(EndpointService.tokenize(config));
        };

        resourceService.getFeedbackRequests = function(resourceId) {
            var config = {
                url: SERVICE_ROOT() + resourceId + "/feedbackrequests",
                method: httpMethods.GET
            };
            return $http(EndpointService.tokenize(config));
        };

        // Business logic for the "Share by link."
        resourceService.getOrganizationPrincipal = function(resourceId) {
            var deferred = $q.defer();

            resourceService.describeResourcePermissions(resourceId, ['PRINCIPALS'])
            .success(function(res) {
                var principals = null,
                    orgPrincipalInfo = null;

                if (res && res.hasOwnProperty('Principals')) {
                    principals = res.Principals;
                    angular.forEach(principals, function(principal) {
                        if (principal.Type === collaboratorTypes.ORGANIZATION) {
                            if (angular.isArray(principal.Roles) && principal.Roles.length > 0) {
                                orgPrincipalInfo = {
                                    Id: principal.Id,
                                    Role: principal.Roles[0].Role
                                };
                            }
                        }
                    });
                    deferred.resolve(orgPrincipalInfo);
                } else {
                    deferred.reject('Principals do not exist.');
                }
            }).error(function() {
                deferred.reject('Failed to get the organization principal.');
            });

            return deferred.promise;
        };

        resourceService.checkout = function(resourceId, optionalComment) {
            if (optionalComment) {
                optionalComment = optionalComment.trim();
            }
            return $http(EndpointService.tokenize({
                method : httpMethods.PUT,
                url : SERVICE_ROOT(true) + resourceId + '/lock',
                data : {
                    Reason : optionalComment
                }
            }));
        };

        resourceService.pokeCheckoutee = function(resourceId, optionalComment, notifyOwners) {
            if (optionalComment) {
                optionalComment = optionalComment.trim();
            }
            return $http(EndpointService.tokenize({
                method : httpMethods.POST,
                url : SERVICE_ROOT(true) + resourceId + '/pokeLockOwner',
                data : {
                    NotifyOwners: notifyOwners,
                    Reason : optionalComment
                }
            }));
        };

        resourceService.checkin = function(resourceId, optionalComment) {
            if (optionalComment) {
                optionalComment = optionalComment.trim();
            }
            return $http(EndpointService.tokenize({
                method : httpMethods.POST,
                url : SERVICE_ROOT(true) + resourceId + '/lock',
                data : {
                    Reason : optionalComment
                }
            }));
        };

        resourceService.discardCheckout = function(resourceId, optionalComment) {
            if (optionalComment) {
                optionalComment = optionalComment.trim();
            }
            return $http(EndpointService.tokenize({
                method : httpMethods.DELETE,
                url : SERVICE_ROOT(true) + resourceId + '/lock',
                data : {
                    Reason : optionalComment
                }
            }));
        };

        resourceService.updateLinkPermissions = function(resourceId, principalId, linkType, linkRole, expiryDate, linkPassword) {
        	
        	var config = {
                url: SERVICE_ROOT() + resourceId + '/permissions',
                method: httpMethods.PUT,
                data: {
                    Principals: [{
                        Id: principalId,
                        Type: linkType,
                        Role: linkRole,
                        ShareSettings:{
                        	ExpirationDate: expiryDate,
                    		Password: linkPassword
                        }
                    }],
                    Options: {
                        Visibility: 'INVISIBLE'
                    }
                }
            };
            
        	return $http(EndpointService.tokenize(config));
        };
        
        resourceService.updateOrgPermissions = function(resourceId, organizationId, role) {
            var deferred = $q.defer(),
                config = {
                    url: SERVICE_ROOT() + resourceId + '/permissions',
                    method: httpMethods.PUT,
                    data: {
                        Principals: [{
                            Id: organizationId,
                            Type: collaboratorTypes.ORGANIZATION,
                            Role: role
                        }],
                        Options: {
                            Visibility: 'INVISIBLE'
                        }
                    }
                };

            $http(EndpointService.tokenize(config)).success(function(res) {
                var shareResults = null;
                if (res && res.hasOwnProperty('ShareResults')) {
                    shareResults = res.ShareResults;
                    if (angular.isArray(shareResults) && shareResults.length > 0) {
                        deferred.resolve({
                            Id: shareResults[0].PrincipalId,
                            Role: shareResults[0].Role,
                        });
                        return;
                    }
                }
                deferred.reject('Succeeded to udpate the organization permissions, but the ShareResults is not available.');
            }).error(function() {
                deferred.reject('Failed to update the organization permissions');
            });

            return deferred.promise;
        };

        // Other functions

        function Principals(direct, inherited) {
            this.direct = direct;
            this.inherited = inherited;
        }

        resourceService.getCurrentUserRoles = function(data, currentUser, isAnonymous) {
            var currentUserRoles = [],
                shouldAdd = false;

            if (isAnonymous) {
                currentUserRoles = [{
                    role: collaboratorTypes.VIEWER
                }];
            } else {
                angular.forEach(data.Principals, function(principal) {
                    angular.forEach(principal.Roles, function(role) {
                        shouldAdd = false;
                        switch (principal.Type) {
                            case collaboratorTypes.USER:
                                shouldAdd = principal.Id === currentUser.Id;
                                break;
                            case collaboratorTypes.GROUP:
                                shouldAdd = principal.ClaimOf === 'CALLER';
                                break;
                            case collaboratorTypes.ORGANIZATION:
                                shouldAdd = principal.Id === currentUser.OrganizationId;
                                break;
                        }

                        if (shouldAdd) {
                            currentUserRoles.push({
                                role: role.Role,
                                roleType: role.Type,
                                // This can be "USER", "GROUP", or "ORGANIZATION" (for link share)
                                principalType: principal.Type
                            });
                        }
                    });
                });
            }

            return currentUserRoles;
        };

        function isFirstRoleMorePermissive(firstRole, secondRole) {
            if (!firstRole || !secondRole || !permissiveDict.hasOwnProperty(firstRole) || !permissiveDict.hasOwnProperty(secondRole)) {
                return false;
            }
            return (permissiveDict[firstRole] - permissiveDict[secondRole]) > 0;
        }

        resourceService.isFirstRoleMorePermissive = isFirstRoleMorePermissive;

        resourceService.processResourcePermissionResponse = function(data, currentUser, isAnonymous) {
            var userMap = data.Users,
                groupMap = data.Groups,
                principals = new Principals([], []),
                currentUserRoles = [],
                principalIdToInheritedPermissionDict = {};

            angular.forEach(data.Principals, function(principal) {

                // Handle case if User or Group metadata is unavailable (don't show it).
                if ((principal.Type === collaboratorTypes.USER && userMap && userMap[principal.Id]) ||
                    (principal.Type === collaboratorTypes.GROUP && groupMap && groupMap[principal.Id]) ||
                    (principal.Type === collaboratorTypes.ORGANIZATION)) {

                    angular.forEach(principal.Roles, function(role) {
                        var permissionObj = {
                                Id: principal.Id,
                                Type: principal.Type,
                                Role: role.Role
                            },
                            visible = true;

                        switch (principal.Type) {
                            case collaboratorTypes.USER:
                                permissionObj.GivenName = userMap[principal.Id].GivenName;
                                permissionObj.EmailAddress = userMap[principal.Id].EmailAddress;
                                permissionObj.Surname = userMap[principal.Id].Surname;
                                permissionObj.Username = userMap[principal.Id].Username;
                                permissionObj.ProfilePhotoThumbnails = userMap[principal.Id].ProfilePhotoThumbnails;

                                if (data.Deadlines && data.Deadlines[principal.Id]) {
                                    permissionObj.Deadline = data.Deadlines[principal.Id];
                                }

                                if (principal.Id === currentUser.Id) {
                                    currentUserRoles.push({
                                        role: role.Role,
                                        roleType: role.Type,
                                        principalType: principal.Type
                                    });
                                }
                                break;
                            case collaboratorTypes.GROUP:
                                permissionObj.Name = groupMap[principal.Id].Name;
                                permissionObj.Vendor = groupMap[principal.Id].Vendor;

                                // If currentUser in this group, add this group's role to currentUserRoles
                                if (principal.ClaimOf === 'CALLER') {
                                    currentUserRoles.push({
                                        role: role.Role,
                                        roleType: role.Type,
                                        principalType: principal.Type
                                    });
                                }
                                break;
                            case collaboratorTypes.ORGANIZATION:
                                // We don't show Org share, but it does factor into current user roles
                                visible = false;
                                if (principal.Id === currentUser.OrganizationId) {
                                    currentUserRoles.push({
                                        role: role.Role,
                                        roleType: role.Type,
                                        principalType: principal.Type
                                    });
                                }
                                break;
                        }

                        if (visible) {
                            // If role type is DIRECT, directly push this permission to principals.
                            if (role.Type === roleTypes.DIRECT) {
                                principals[role.Type.toLowerCase()].push(permissionObj);
                            } else {
                                // If role type is INHERITED, save the most permissive one without pushing to principals 
                                // because service will return all inherited roles.
                                if (!principalIdToInheritedPermissionDict.hasOwnProperty(permissionObj.Id)) {
                                    principalIdToInheritedPermissionDict[permissionObj.Id] = permissionObj;
                                } else { 
                                    var previousRole = principalIdToInheritedPermissionDict[permissionObj.Id].Role;
                                    var currentRole = permissionObj.Role;
                                    if (isFirstRoleMorePermissive(currentRole, previousRole)) {
                                        principalIdToInheritedPermissionDict[permissionObj.Id] = permissionObj;
                                    }
                                }
                            }
                        }
                        
                    });
                }
            });

            // Finally, push inherited permissions saved in principalIdToInheritedPermissionDict to principals.
            for (var key in principalIdToInheritedPermissionDict) {
                principals[roleTypes.INHERITED.toLowerCase()].push(principalIdToInheritedPermissionDict[key]);
            }

            // HACK-ish: Anonymous user always has VIEWER role.
            if (isAnonymous) {
                currentUserRoles = [{
                    role: collaboratorTypes.VIEWER
                }];
            }

            return {
                principals: principals,
                currentUserRoles: currentUserRoles
            };
        };

        resourceService.processUserRightsFromRoles = function(userRoles) {
            var userRights = RightsUtil.newRightSet();

            angular.forEach(userRoles, function(roleObj) {
                switch (roleObj.role) {
                    case globalRoles.OWNER:
                        userRights.add(
                            permissions.VIEW,
                            permissions.CONTRIBUTE,
                            permissions.DISCARD_CHECKOUT,
                            permissions.CHECKOUT,
                            permissions.CHECKIN,
                            permissions.DOWNLOAD,
                            permissions.SHARE,
                            permissions.SHARE_ANONYMOUSLY,
                            permissions.DELETE,
                            permissions.MOVE,
                            permissions.RENAME);
                        break;
                    case globalRoles.COOWNER:
                        userRights.add(
                            permissions.VIEW,
                            permissions.DISCARD_CHECKOUT,
                            permissions.CHECKOUT,
                            permissions.CHECKIN,
                            permissions.CONTRIBUTE,
                            permissions.DOWNLOAD,
                            permissions.SHARE,
                            permissions.SHARE_ANONYMOUSLY,
                            permissions.DELETE,
                            permissions.MOVE,
                            permissions.RENAME);
                        break;
                    case globalRoles.CONTRIBUTOR:
                        userRights.add(
                            permissions.VIEW,
                            permissions.CHECKOUT,
                            permissions.CHECKIN,
                            permissions.CONTRIBUTE);
                        break;
                    case globalRoles.VIEWER:
                        userRights.add(permissions.VIEW);
                        break;
                }
            });

            return userRights;
        };

        resourceService.getOwnerId = function(docOrFolder) {
            // The resource collection v2 provides a list of documents and folders, each of which contains OwnerId but no Owner metadata.
            // The v1 has an Owner metadata but null OwnerId.
            return docOrFolder.OwnerId || (docOrFolder.Owner && docOrFolder.Owner.Id) || docOrFolder.CreatorId;
        };

        return resourceService;
    }

}());
